import { render, staticRenderFns } from "./finance_button_multi.vue?vue&type=template&id=20a5e8c0&scoped=true"
import script from "./finance_button_multi.vue?vue&type=script&lang=js"
export * from "./finance_button_multi.vue?vue&type=script&lang=js"
import style0 from "./finance_button_multi.vue?vue&type=style&index=0&id=20a5e8c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5e8c0",
  null
  
)

export default component.exports